import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import type { RestrictedFieldsSet } from './SupplierProfileBuilder_NEW';

interface SupplierProfileBuilderStepFinancialIdentityProps {
  restrictedFields: RestrictedFieldsSet;
  setRestrictedFields: React.Dispatch<
    React.SetStateAction<RestrictedFieldsSet>
  >;
  setChangesSaved: React.Dispatch<React.SetStateAction<boolean>>;
}

const SupplierProfileBuilderStepFinancialIdentity: React.FC<
  SupplierProfileBuilderStepFinancialIdentityProps
> = ({
  restrictedFields,
  setRestrictedFields,
  setChangesSaved,
}) => {
  return (
    <div>
      {restrictedFields.is_financials_public ? (
        <div className="alert alert-warning mb-4">
          <i className="bi bi-shield-lock-fill me-2"></i>
          This information is <strong>available</strong> to all users, including
          non-logged in buyers. Consider the implications of making this public.
        </div>
      ) : (
        <div className="alert alert-info mb-4">
          <i className="bi bi-shield-lock-fill me-2"></i>
          This information is <strong>restricted to logged-in buyers</strong> by
          default unless you enable public access below.
        </div>
      )}

      <Row className="mb-4">
        <Col>
          <Form.Check
            type="switch"
            id="is-public-switch"
            label="Make this entire section public"
            checked={restrictedFields.is_financials_public || false}
            onChange={(e) => {
              setRestrictedFields({
                ...restrictedFields,
                is_financials_public: e.target.checked,
              });
              setChangesSaved(false);
            }}
          />
          <Form.Text className="text-muted">
            Turn this on if you want non-logged in users to see your financial
            and identity details.
          </Form.Text>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Ultimate Beneficial Owner (UBO)</Form.Label>
                <Form.Control
                  placeholder="Full names of owners with >25%"
                  value={restrictedFields.ubo_details || ''}
                  onChange={(e) => {
                    setRestrictedFields({
                      ...restrictedFields,
                      ubo_details: e.target.value,
                    });
                    setChangesSaved(false);
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sanctions screening status</Form.Label>
                <Form.Select
                  value={
                    restrictedFields.sanction_screening_status || 'not_screened'
                  }
                  onChange={(e) => {
                    setRestrictedFields({
                      ...restrictedFields,
                      sanction_screening_status: e.target.value,
                    });
                    setChangesSaved(false);
                  }}
                >
                  <option value="not_screened">Not Screened</option>
                  <option value="clear">Clear</option>
                  <option value="flagged">Flagged</option>
                  <option value="watchlist">Watchlist</option>
                  <option value="pending">Pending</option>
                  <option value="error">Error</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Credit Score</Form.Label>
                <Form.Control
                  placeholder="e.g. AAA or 750"
                  value={restrictedFields.credit_score_value || ''}
                  onChange={(e) => {
                    setRestrictedFields({
                      ...restrictedFields,
                      credit_score_value: e.target.value,
                    });
                    setChangesSaved(false);
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Score Provider</Form.Label>
                <Form.Control
                  placeholder="e.g. Creditinfo"
                  value={restrictedFields.credit_score_provider || ''}
                  onChange={(e) => {
                    setRestrictedFields({
                      ...restrictedFields,
                      credit_score_provider: e.target.value,
                    });
                    setChangesSaved(false);
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Last Financial Audit Date</Form.Label>
                <Form.Control
                  type="date"
                  value={restrictedFields.last_financial_audit_date || ''}
                  onChange={(e) => {
                    setRestrictedFields({
                      ...restrictedFields,
                      last_financial_audit_date: e.target.value,
                    });
                    setChangesSaved(false);
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default SupplierProfileBuilderStepFinancialIdentity;
